<template>
    <div v-if="mostrar" class="modal-overlay">
      <div class="modal-container">
        <!-- Header -->
        <div class="modal-header">
          <h5>Avaliação de Mudança de Nível</h5>
          <button class="btn-close" @click="fechar"></button>
        </div>
  
        <div class="modal-body">
          <!-- Info inicial -->
          <ul class="list-unstyled mb-3">
            <li><strong>Instrutor:</strong> {{ supervisao.instrutor }}</li>
            <li><strong>Aluno:</strong> {{ supervisao.aluno }}</li>

              <p class="mb-1">
                <strong>Turma: </strong>

                <!-- Enquanto carrega o /prova, não mostra mensagem de matrícula -->
                <span v-if="carregandoMeta" class="text-muted">Carregando…</span>

                <!-- Depois que carregou, aplica as regras -->
                <template v-else>
                  <span v-if="matriculaAtiva && supervisaoTemHorario">
                    {{ supervisao.turma }}
                    <span>
                      —
                      {{ corrigirDiaSemana(diaSemanaExibicao) }}
                      •
                      {{ formatarHorario(horarioExibicao) }}
                    </span>
                  </span>

                  <span v-else-if="matriculaAtiva">
                    {{ supervisao.turma }}
                    <br />
                    <span class="text-muted">(Sem dia/horário vinculado para exibição.)</span>
                  </span>

                  <span v-else>
                    {{ supervisao.turma }}
                    <br />
                    <span class="text-danger">
                      Matrícula do aluno não está ativa. Não é possível realizar a Avaliação.
                    </span>
                  </span>
                </template>
              </p>

            <li><strong>Data:</strong> {{ dataExibicao }}</li>
          </ul>
          <p><strong>Realizada por:</strong> {{ supervisao.por === null ? userName : supervisao.por }}</p>
  
          <!-- Seleções -->
          <div class="mb-3">
            <label class="form-label">Animal <span class="required">*</span></label>
            <select v-model="form.animalId" class="form-select" :disabled="camposDesabilitados">
              <option value="" disabled>Selecione um animal</option>
              <option v-for="a in animais" :key="a.id" :value="a.id">
                {{ a.nome }}
              </option>
            </select>
          </div>
  
          <div class="mb-3">
            <label class="form-label">Formulário <span class="required">*</span></label>
            <select v-model="form.formularioId" class="form-select" :disabled="camposDesabilitados">
              <option value="" disabled>Selecione um formulário</option>
              <option v-for="f in formularios" :key="f.id" :value="f.id">
                {{ f.formulario }}
              </option>
            </select>
          </div>
  
          <!-- Questões -->
          <div v-if="questoes.length" class="mb-3">
            <div v-for="q in questoes" :key="q.id" class="mb-4">
              <p><strong>{{ q.questao }}</strong></p>
              <!-- Múltipla seleção -->
              <div v-if="q.tipo_dado === 'Múltipla seleção'">
                <div v-for="opt in sortedOptions(q)" :key="opt.id" class="form-check">
                    <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'opt-'+q.id+'-'+opt.id"
                    :value="opt.id"
                    :disabled="somenteLeitura"
                    v-model="form.respostas[q.id]"
                  >
                  <label class="form-check-label" :for="'opt-'+q.id+'-'+opt.id">
                    {{ opt.opcao }}
                  </label>
                </div>
              </div>
              <!-- Numérico -->
              <div v-else-if="q.tipo_dado === 'Numérico'">
                <div v-for="opt in sortedOptions(q)" :key="opt.id" class="d-flex align-items-center mb-2">
                  <div class="flex-fill">
                    <p>{{ opt.opcao }}</p>
                  </div>
                    <select
                        class="form-select form-select-sm"
                        v-model.number="form.respostas[q.id][opt.id]"
                        style="width: 100px;"
                        :disabled="somenteLeitura"
                        >
                        <option value="" disabled>---</option>
                        <option
                            v-for="val in [
                            0,
                            Number((opt.pontuacao / 2).toFixed(2)),
                            opt.pontuacao
                            ]"
                            :key="val"
                            :value="val"
                        >
                            {{ formatar(val) }}
                        </option>
                    </select>
                </div>
              </div>
            </div>
          </div>
  
          <!-- Total e aprovado -->
          <div class="mb-3">
            <p><strong>Nota Total:</strong> {{ formatar(notaTotal) }}</p>
            <p>
              <strong>Status:</strong>
              <span :class="notaTotal >= 7 ? 'text-success' : 'text-danger'">
                {{ notaTotal >= 7 ? 'Aprovado' : 'Reprovado (mín 7,00)' }}
              </span>
            </p>
          </div>
        </div>
  
        <!-- Por este novo: -->
        <div class="modal-footer">
          <template v-if="somenteLeitura">
            <button class="btn btn-secondary" @click="fechar">Fechar</button>
          </template>
          <template v-else>
            <button class="btn btn-secondary" @click="fechar">Cancelar</button>
            <!-- Finalizar -->
            <button
              class="btn btn-success"
              @click="finalizar"
              :disabled="isFinalizando || !okParaFinalizar"
            >
              {{ isFinalizando ? 'Finalizando…' : 'Finalizar' }}
            </button>

            <!-- Salvar -->
            <button
              class="btn btn-primary"
              @click="salvar"
              :disabled="isSubmitting || !okParaSalvar"
            >
              {{ isSubmitting ? 'Salvando…' : 'Salvar' }}
            </button>
          </template>
        </div>
        
      </div>
    </div>
  </template>
  
<script setup>
import { ref, reactive, computed, onMounted, watch, getCurrentInstance } from 'vue';
import axios from '@/services/axios';
import globalUtils from '@/utils/globalUtils';

// =========================
// Props / Emits
// =========================
const props = defineProps({
  mostrar: { type: Boolean, default: false },
  supervisao: { type: Object, required: true },
  modoVisualizacao: { type: Boolean, default: false }
});

const emit = defineEmits(['close', 'salvou']);

// =========================
// GlobalState / userName
// =========================
const instance = getCurrentInstance();
const gs = instance?.appContext?.config?.globalProperties?.$globalState;
const userName = gs?.userName || '';

// =========================
// Estado principal
// =========================
const somenteLeitura = ref(false);
const animais = ref([]);
const formularios = ref([]);
const questoes = ref([]);
const isSubmitting = ref(false);
const isFinalizando = ref(false);
const oldRespostas = ref({});

// Detalhe vindo do /prova (fonte de verdade para matricula_ativa, dia_semana, horario, etc.)
const detalhe = ref(null);

// (opcional) ajuda UX enquanto carrega meta
const carregandoMeta = ref(false);

// =========================
// Form reativo
// =========================
const form = reactive({
  animalId: '',
  formularioId: '',
  respostas: {}
});

// =========================
// Computeds de supervisão / exibição
// =========================
const supervisao = computed(() => props.supervisao || {});

// Fonte “melhor”: detalhe do /prova; fallback: props.supervisao (listagem)
const sExib = computed(() => detalhe.value ?? props.supervisao ?? {});

// Matrícula ativa e dia/horário (lidos da fonte correta)
const matriculaAtiva = computed(() => !!sExib.value.matricula_ativa);

const diaSemanaExibicao = computed(() => sExib.value.dia_semana || null);
const horarioExibicao = computed(() => sExib.value.horario || null);

const supervisaoTemHorario = computed(() => !!diaSemanaExibicao.value && !!horarioExibicao.value);

// Desabilita se somente leitura OU matrícula não ativa
// enquanto carrega meta, desabilita para não ficar “piscando”
const camposDesabilitados = computed(() => {
  if (carregandoMeta.value) return true;
  return somenteLeitura.value || !matriculaAtiva.value;
});

// Data exibida no modal: hoje ou data_realizacao em visualização
const dataExibicao = computed(() => {
  if (props.modoVisualizacao && props.supervisao?.data_realizacao) {
    return globalUtils.formatarData(props.supervisao.data_realizacao);
  }
  return globalUtils.formatarData(new Date().toISOString());
});

// =========================
// Helpers
// =========================
function sortedOptions(q) {
  const lower = (s) => String(s || '').toLowerCase().trim();
  const all = Array.isArray(q.opcoes) ? q.opcoes : [];

  const others = all.filter((o) => lower(o.opcao) === 'outros');
  const rest = all
    .filter((o) => lower(o.opcao) !== 'outros')
    .slice()
    .sort((a, b) => String(a.opcao || '').localeCompare(String(b.opcao || '')));

  return [...rest, ...others];
}

function corrigirDiaSemana(dia) {
  if (!dia) return '';
  const mapa = {
    domingo: 'Domingo',
    'segunda-feira': 'Segunda-feira',
    segunda: 'Segunda-feira',
    'terça-feira': 'Terça-feira',
    'terca-feira': 'Terça-feira',
    terça: 'Terça-feira',
    terca: 'Terça-feira',
    'quarta-feira': 'Quarta-feira',
    quarta: 'Quarta-feira',
    'quinta-feira': 'Quinta-feira',
    quinta: 'Quinta-feira',
    'sexta-feira': 'Sexta-feira',
    sexta: 'Sexta-feira',
    sábado: 'Sábado',
    sabado: 'Sábado'
  };
  const key = String(dia).trim().toLowerCase();
  return mapa[key] || dia;
}

function formatarHorario(horario) {
  if (!horario) return '';
  // pode vir como '16:00:00' ou '16:00'
  return horario.toString().slice(0, 5);
}

// Formata número com vírgula
function formatar(n) {
  if (n == null || Number.isNaN(Number(n))) return '';
  return Number(n).toFixed(2).replace('.', ',');
}

// =========================
// Fetches
// =========================
async function fetchMeta() {
  carregandoMeta.value = true;
  try {
    const res = await axios.get(`/operacional/supervisoes/${props.supervisao.id}/prova`);
    animais.value = res.data.animais || [];
    formularios.value = res.data.formularios || [];

    const sup = res.data.supervisao || {};
    detalhe.value = sup; // ✅ fonte real para matricula_ativa / dia_semana / horario

    oldRespostas.value = sup.respostas || {};
    return sup;
  } finally {
    carregandoMeta.value = false;
  }
}

async function fetchQuestoes(formId, old = {}) {
  questoes.value = [];

  const res = await axios.get(
    `/operacional/supervisoes/${props.supervisao.id}/prova/formulario/${formId}`
  );

  form.respostas = {};

  (res.data || []).forEach((q) => {
    if (q.tipo_dado === 'Múltipla seleção') {
      form.respostas[q.id] = Array.isArray(old[q.id]) ? [...old[q.id]] : [];
    } else {
      form.respostas[q.id] = {};
      (q.opcoes || []).forEach((opt) => {
        const v = old[q.id] && old[q.id][opt.id];
        if (v != null) form.respostas[q.id][opt.id] = v;
      });
    }
  });

  questoes.value = res.data || [];
}

// =========================
// Nota total
// =========================
const notaTotal = computed(() => {
  let soma = 0;

  for (const q of questoes.value) {
    if (q.tipo_dado === 'Múltipla seleção') {
      const opts = Array.isArray(q.opcoes) ? q.opcoes : [];
      const isOutros = (o) => String(o.opcao || '').trim().toLowerCase() === 'outros';

      const totalFromOpts = opts
        .filter((o) => !isOutros(o))
        .reduce((sum, o) => sum + Number(o.pontuacao || 0), 0);

      const rawP = q.pontuacao;
      const numP =
        rawP != null
          ? typeof rawP === 'number'
            ? rawP
            : parseFloat(String(rawP).replace(',', '.'))
          : totalFromOpts;

      const validCount = opts.filter((o) => !isOutros(o)).length;

      const unit = validCount > 0 && !Number.isNaN(numP) ? numP / validCount : 0;

      const marcados = Array.isArray(form.respostas[q.id]) ? form.respostas[q.id] : [];

      const contagem = marcados.filter((id) => {
        const opt = opts.find((o) => o.id === id);
        return opt && !isOutros(opt);
      }).length;

      soma += contagem * unit;
    } else {
      const respObj = form.respostas[q.id] || {};
      for (const [, pt] of Object.entries(respObj)) {
        // aqui mantém teu comportamento: só soma se "truthy"
        if (pt || pt === 0) soma += Number(pt);
      }
    }
  }

  return Math.round(soma * 100) / 100;
});

// =========================
// Validações de salvar/finalizar
// =========================
const okParaSalvar = computed(() => {
  if (!form.animalId || !form.formularioId) return false;
  if (!questoes.value.length) return false;

  return questoes.value.every((q) => {
    const opts = Array.isArray(q.opcoes) ? q.opcoes : [];
    const ehOutros = (o) => String(o.opcao || '').trim().toLowerCase() === 'outros';
    const optsValidas = opts.filter((o) => !ehOutros(o));

    if (q.tipo_dado === 'Múltipla seleção') {
      const marcados = Array.isArray(form.respostas[q.id]) ? form.respostas[q.id] : [];
      // precisa ter ao menos um marcado que NÃO seja "Outros"
      return marcados.some((idMarc) => {
        const opt = opts.find((o) => o.id === idMarc);
        return opt && !ehOutros(opt);
      });
    }

    // Numérico: cada opção válida precisa ter um número definido (0 conta)
    const resp = form.respostas[q.id] || {};
    return optsValidas.every((opt) => {
      const v = resp[opt.id];
      return v === 0 || (typeof v === 'number' && !Number.isNaN(v));
    });
  });
});

const okParaFinalizar = computed(() => okParaSalvar.value && notaTotal.value >= 7);

// =========================
// Ações
// =========================
async function salvar() {
  if (!okParaSalvar.value || isSubmitting.value || isFinalizando.value) return;
  isSubmitting.value = true;

  try {
    const payload = {
      animal_id: form.animalId,
      formulario_id: form.formularioId,
      respostas: form.respostas,
      data_realizacao: dataExibicao.value.split('/').reverse().join('-'),
      realizada: true,
      nota_avaliacao: notaTotal.value,
      aprovado: notaTotal.value >= 7,
      finalizada: false,
      por: userName
    };

    await axios.patch(`/operacional/supervisoes/${props.supervisao.id}`, payload);
    emit('salvou');
    fechar();
  } catch (err) {
    console.error('Erro ao salvar avaliação:', err);
  } finally {
    isSubmitting.value = false;
  }
}

async function finalizar() {
  if (!okParaSalvar.value || isSubmitting.value || isFinalizando.value) return;
  isFinalizando.value = true;

  try {
    const payload = {
      animal_id: form.animalId,
      formulario_id: form.formularioId,
      respostas: form.respostas,
      data_realizacao: dataExibicao.value.split('/').reverse().join('-'),
      realizada: true,
      nota_avaliacao: notaTotal.value,
      aprovado: notaTotal.value >= 7,
      finalizada: true,
      por: userName
    };

    await axios.patch(`/operacional/supervisoes/${props.supervisao.id}`, payload);
    emit('salvou');
    fechar();
  } catch (err) {
    console.error('Erro ao finalizar avaliação:', err);
  } finally {
    isFinalizando.value = false;
  }
}

function fechar() {
  emit('close');
}

// =========================
// Watches
// =========================
watch(
  () => form.formularioId,
  async (fId) => {
    if (!fId) {
      questoes.value = [];
      return;
    }
    await fetchQuestoes(fId, oldRespostas.value);
  }
);

// =========================
// Mount
// =========================
onMounted(async () => {
  const sup = await fetchMeta();

  form.animalId = sup?.animal_id || '';
  form.formularioId = sup?.formulario_id || '';

  if (form.formularioId) {
    await fetchQuestoes(form.formularioId, sup?.respostas || {});
  }

  // ✅ respeita modo visualização + finalizada
  somenteLeitura.value = !!props.modoVisualizacao;
});
</script>
  
  
  <style scoped>
  .modal-overlay {
    position: fixed; top:0; left:0; right:0; bottom:0;
    background: rgba(0,0,0,.5);
    display: flex; align-items: center; justify-content: center;
    z-index: 1050;
  }
  .modal-container {
    background: #fff; width: 100%; max-width: 700px;
    border-radius: 0; overflow: hidden;
  }
  .modal-header {
    background: #f5f5f5; padding: .75rem 1rem;
    display: flex; justify-content: space-between; align-items: center;
  }
  .modal-body { padding: 1rem; max-height: 70vh; overflow-y: auto; }
  .modal-footer {
    padding: .75rem 1rem; display: flex; justify-content: flex-end; gap: .5rem;
    background: #f5f5f5;
  }

.modal-body label.form-label,
.modal-body .form-check-label {
  font-size: 0.7rem;
}

/* Reduz tamanho dos checkboxes de múltipla seleção */
.form-check-input {
  width: 10px;
  height: 10px;
}

/* Torna o container flex para alinhar checkbox + texto */
/* Alinha checkbox + texto exatamente no centro */
.modal-body .form-check {
  display: flex !important;
  align-items: center !important;
  margin-bottom: 0.25rem;
}

/* Remove margens/paddings padrões do input */
.modal-body .form-check-input {
  margin: 0 !important;
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
}

/* Garante que o label não tenha margin que atrapalhe */
.modal-body .form-check-label {
  margin: 0 0 0 0.5rem !important; /* 0.5rem de espaço após o checkbox */
  padding: 0;
}

/* Para todas as linhas numéricas e de múltipla seleção */
.modal-body .d-flex.align-items-center.mb-2 {
  align-items: baseline !important;
}

/* Garante um gap razoável entre texto e select */
.modal-body .d-flex.align-items-baseline > .form-select {
  margin-left: 0.5rem;
}

.btn {
  min-width: 70px;
  padding: 6px 15px;
  font-size: 14px;
  cursor: pointer;
  border: none;
}


.required { color: red; }


  </style>
  